import React from 'react';
import { Hint, HintContent, Icon, IconButton, Typography } from 'fronton-react';
import { patchUrlByLocale } from 'utils';
import { StoreStockData } from './types';
import {
  stockInStoresTitleText,
  stockInStoresTitleContainer,
  TitleNoInteractiveContainer,
  QuestionMarkContainer,
  questionIconStyle,
} from './styles';
import { createStoreLink } from './utils/create-store-link';
import { useTranslation } from 'react-i18next';
import { QuestionIcon } from '@fronton/icons-react';
import { useBreakpoints } from 'common/hooks';
import { DisplayTooltipModal } from './display-tooltip-modal';
import { QuestionIconButton } from './question-icon-button';

type TitleNonInteractiveProps = {
  availableStore: StoreStockData | null;
  regionCode: string;
  stocks: StoreStockData[];
};

export const TitleNonInteractive: React.FC<TitleNonInteractiveProps> = ({
  availableStore,
  regionCode,
  stocks,
}) => {
  const { t } = useTranslation();
  const { mobile } = useBreakpoints() || {
    mobile: false,
  };
  const [hintOpen, setHintOpen] = React.useState(false);
  const url = patchUrlByLocale(createStoreLink(regionCode, stocks) as string);
  const isDisplay = availableStore?.stockValue === 0 && availableStore?.displaySample;

  return (
    <TitleNoInteractiveContainer>
      <a className={stockInStoresTitleContainer} data-qa="stock-in-stores-title-non-interactive" href={url}>
        <Typography
          className={stockInStoresTitleText}
          color={isDisplay ? 'secondary-blue-primary' : 'control-primary'}
          size="body_accent"
          variant="s"
        >
          {isDisplay ? `${t('product-info.stocks.in-stores.has-sample')} ` : ''}
          {availableStore?.storeFullName}
        </Typography>
      </a>

      {isDisplay && (
        <QuestionMarkContainer>
          {mobile ? (
            <>
              <IconButton
                onClick={() => setHintOpen(!hintOpen)}
                className={questionIconStyle}
                aria-label={t('product-info.stocks.in-stores.aria-label-tooltip')}
              >
                <Icon color="secondary-blue-primary" size="l">
                  <QuestionIcon />
                </Icon>
              </IconButton>{' '}
              <DisplayTooltipModal modalVisibility={hintOpen} setModalVisibility={setHintOpen} />
            </>
          ) : (
            <Hint
              anchor={
                <QuestionIconButton
                  onMouseEnter={() => setHintOpen(true)}
                  onMouseLeave={() => setHintOpen(false)}
                />
              }
              placement="bottom-end"
              open={hintOpen}
            >
              <HintContent paragraph={t('product-info.stocks.in-stores.tooltip-content')} />
            </Hint>
          )}
        </QuestionMarkContainer>
      )}
    </TitleNoInteractiveContainer>
  );
};
